import { COLORS } from '@repo/design-system/index'
import { QIcon_close_bold, QIcon_mic_default } from '@repo/icons/index'
import dynamic from 'next/dynamic'
import { useEffect, useState } from 'react'
import animationData from '../../../../animations/waveform.json'
import { n_ai_speaking } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import LoadingSpinner from '../../../common/LoadingSpinner'

const Lottie = dynamic(() => import('react-lottie'), { ssr: false })

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
} as const

//recordingStatus-> idle, cancelling, starting, recording, stopping, preparing, waiting
const RecordWrapper = ({ recordingStatus, setRecordingStatus, onCancel }) => {
  const { t } = useTranslation()

  // const recordingStatus = 'waiting'

  const [micTextIndex, setMicTextIndex] = useState(0)
  const micTextArray = [
    t(n_ai_speaking.ai_session.msg1),
    t(n_ai_speaking.ai_session.msg2),
    // t(n_ai_speaking.ai_session.msg3),
  ]
  const [fixMicTextForTenSeconds, setFixMicTextForTenSeconds] = useState(true)

  useEffect(() => {
    let interval

    if (fixMicTextForTenSeconds) {
      setTimeout(() => {
        setFixMicTextForTenSeconds(false)
      }, 10000)
    } else {
      interval = setInterval(() => {
        const nextIndex = (micTextIndex + 1) % micTextArray.length
        setMicTextIndex(nextIndex)
      }, 3000)
    }

    return () => clearInterval(interval)
  }, [micTextIndex, fixMicTextForTenSeconds])

  useEffect(() => {
    //▶️ 다른 모든 리스너는 없애고, 오디오에 직접적으로 사용되는 리스너는 여기에 존재합니다.
    function handleMessage(event) {
      let data
      try {
        data = JSON.parse(event.data)
      } catch (e) {
        console.error('Invalid message format:', e)
        return
      }
    }

    window.addEventListener('message', handleMessage)
    document.addEventListener('message', handleMessage) // iOS 대응

    // 클린업
    return () => {
      window.removeEventListener('message', handleMessage)
      document.removeEventListener('message', handleMessage)
    }
  }, [])

  return (
    <div className="flex flex-col items-center justify-center items-center">
      {recordingStatus === 'idle' && (
        <div className="bg-white text-center flex items-center justify-center h-[32px]">
          <div className="items-center justify-center Body2-14Md text-gray-500 flex">{micTextArray[micTextIndex]}</div>
        </div>
      )}
      <div>
        {recordingStatus === 'idle' && (
          <>
            <div
              className="mt-[12px] flex flex-col items-center justify-center bg-purple-500
            rounded-[100px] w-[64px] h-[64px] cursor-pointer hover:bg-purple-600 active:bg-purple-700"
              onClick={(_e) => {
                if (recordingStatus === 'cancelling') {
                  return
                }
                setRecordingStatus('starting')
                setTimeout(() => {
                  window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'startRecording' }))
                }, 100)
              }}
            >
              <QIcon_mic_default width={32} height={32} className="bg-contain" color={COLORS.WHITE} />
            </div>
          </>
        )}
        {recordingStatus === 'recording' && (
          <div className="flex flex-row gap-x-[16px] items-center">
            <div
              style={{
                width: 44,
                height: 44,
                borderRadius: 44,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0px 1.375px 5.5px 0px rgba(0, 0, 0, 0.15)',
              }}
              onClick={onCancel}
            >
              <QIcon_close_bold />
            </div>

            <div
              className="bg-purple-500"
              style={{ width: 64, height: 64, borderRadius: 64 }}
              onClick={(e) => {
                setRecordingStatus('stopping')
                window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'stopRecording' }))
              }}
            >
              <Lottie options={defaultOptions} isClickToPauseDisabled={true} />
            </div>

            <div style={{ width: 44, height: 44 }}></div>
          </div>
        )}
      </div>
      {(recordingStatus === 'starting' ||
        recordingStatus === 'stopping' ||
        recordingStatus === 'preparing' ||
        recordingStatus === 'cancelling' ||
        recordingStatus === 'waiting') && (
        <div className="w-[64px] h-[64px]">
          <LoadingSpinner lg show primary />
        </div>
      )}
    </div>
  )
}

export default RecordWrapper
